// extracted by mini-css-extract-plugin
module.exports = {"tabChangeAnimation":"tab_tabChangeAnimation__G1wgl","fadeOut":"tab_fadeOut__06geW"};